/* eslint-disable react-hooks/exhaustive-deps */
import { useReducer, useMemo, useCallback, memo, useEffect } from 'react';
import NotificationsContext from './NotificationsContext';
import initialNotificationsState from './initialNotificationsState';
import userReducer from 'contexts/notifications/reducer/notifications.reducer';
import * as action from 'contexts/notifications/reducer/notifications.actions';
import { useTranslation } from 'react-i18next';
import { ChildrenProps } from 'interfaces/general.interface';
import { useAuth0 } from '@auth0/auth0-react';

function NotificationsProvider(props: ChildrenProps) {
  const [notifications, dispatch] = useReducer(userReducer, initialNotificationsState);
  const { t: translate } = useTranslation();
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    action.getNotificationsAction(dispatch, translate);
  }, []);

  const getNotificationsTypes = useCallback(async () => {
    const token = await getAccessTokenSilently();
    return await action.getNotificationsTypesAction({
      dispatch,
      translate,
      token: token,
    });
  }, []);

  const markAsReaded = useCallback(
    (type: string, notificationId: string, read: boolean) => {
      action.markAsReadedAction(dispatch, type, notificationId, read, translate);
    },
    []
  );

  const memoProvider = useMemo(
    () => ({
      ...notifications,
      getNotificationsTypes,
      markAsReaded,
    }),
    [notifications, getNotificationsTypes, markAsReaded]
  );

  return (
    <NotificationsContext.Provider value={memoProvider}>
      {props.children}
    </NotificationsContext.Provider>
  );
}

export default memo(NotificationsProvider);
